var cov_hm60s0hjm = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Popover/Confirm.tsx",
      hash = "f1fc4ebe9ed95a2f8c1f6b8456953adeac8f0ef1",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Popover/Confirm.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 26
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "1": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 16
        }
      },
      "2": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 32,
          column: 5
        }
      },
      "3": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 61
        }
      },
      "4": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 53
        }
      },
      "5": {
        start: {
          line: 39,
          column: 31
        },
        end: {
          line: 39,
          column: 41
        }
      },
      "6": {
        start: {
          line: 40,
          column: 15
        },
        end: {
          line: 40,
          column: 46
        }
      },
      "7": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 27
        }
      },
      "8": {
        start: {
          line: 42,
          column: 12
        },
        end: {
          line: 42,
          column: 27
        }
      },
      "9": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "10": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 49,
          column: 8
        }
      },
      "11": {
        start: {
          line: 45,
          column: 9
        },
        end: {
          line: 48,
          column: 10
        }
      },
      "12": {
        start: {
          line: 46,
          column: 10
        },
        end: {
          line: 46,
          column: 17
        }
      },
      "13": {
        start: {
          line: 47,
          column: 10
        },
        end: {
          line: 47,
          column: 42
        }
      },
      "14": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 13
        }
      },
      "15": {
        start: {
          line: 56,
          column: 97
        },
        end: {
          line: 56,
          column: 107
        }
      },
      "16": {
        start: {
          line: 57,
          column: 27
        },
        end: {
          line: 57,
          column: 37
        }
      },
      "17": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 79,
          column: 5
        }
      },
      "18": {
        start: {
          line: 61,
          column: 10
        },
        end: {
          line: 76,
          column: 16
        }
      },
      "19": {
        start: {
          line: 69,
          column: 67
        },
        end: {
          line: 69,
          column: 91
        }
      },
      "20": {
        start: {
          line: 72,
          column: 77
        },
        end: {
          line: 72,
          column: 97
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 42
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 27
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 54
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 38
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 44,
            column: 38
          },
          end: {
            line: 44,
            column: 39
          }
        },
        loc: {
          start: {
            line: 44,
            column: 44
          },
          end: {
            line: 49,
            column: 7
          }
        },
        line: 44
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 45,
            column: 41
          },
          end: {
            line: 45,
            column: 42
          }
        },
        loc: {
          start: {
            line: 45,
            column: 47
          },
          end: {
            line: 48,
            column: 9
          }
        },
        line: 45
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        },
        loc: {
          start: {
            line: 55,
            column: 11
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 55
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 60,
            column: 9
          },
          end: {
            line: 60,
            column: 10
          }
        },
        loc: {
          start: {
            line: 61,
            column: 10
          },
          end: {
            line: 76,
            column: 16
          }
        },
        line: 61
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 69,
            column: 61
          },
          end: {
            line: 69,
            column: 62
          }
        },
        loc: {
          start: {
            line: 69,
            column: 67
          },
          end: {
            line: 69,
            column: 91
          }
        },
        line: 69
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 72,
            column: 71
          },
          end: {
            line: 72,
            column: 72
          }
        },
        loc: {
          start: {
            line: 72,
            column: 77
          },
          end: {
            line: 72,
            column: 97
          }
        },
        line: 72
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 40,
            column: 15
          },
          end: {
            line: 40,
            column: 46
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 40,
            column: 31
          },
          end: {
            line: 40,
            column: 35
          }
        }, {
          start: {
            line: 40,
            column: 38
          },
          end: {
            line: 40,
            column: 46
          }
        }],
        line: 40
      },
      "1": {
        loc: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 27
          }
        }, {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 27
          }
        }],
        line: 42
      },
      "2": {
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }],
        line: 43
      },
      "3": {
        loc: {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 16
          }
        }, {
          start: {
            line: 43,
            column: 20
          },
          end: {
            line: 43,
            column: 55
          }
        }],
        line: 43
      },
      "4": {
        loc: {
          start: {
            line: 56,
            column: 22
          },
          end: {
            line: 56,
            column: 46
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 56,
            column: 29
          },
          end: {
            line: 56,
            column: 46
          }
        }],
        line: 56
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Popover/Confirm.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import Popover from './Panel';
import Button from '../Button';
import Alert from '../Alert';
import { Component } from '../component';
import { popoverClass } from './styles';
import { getLocale } from '../locale';
var DefaultProps = (cov_hm60s0hjm.s[0]++, {
  type: 'confirmwarning',
  icon: true,
  okType: 'danger'
});

var Confirm =
/*#__PURE__*/
function (_Component) {
  _inherits(Confirm, _Component);

  var _super = _createSuper2(Confirm);

  function Confirm(props) {
    var _this;

    _classCallCheck(this, Confirm);

    cov_hm60s0hjm.f[0]++;
    cov_hm60s0hjm.s[1]++;
    _this = _super.call(this, props);
    _this.handleCancel = void 0;
    _this.handleOk = void 0;
    cov_hm60s0hjm.s[2]++;
    _this.state = {
      ok: false,
      cancel: false
    };
    cov_hm60s0hjm.s[3]++;
    _this.handleCancel = _this.handleClick.bind(_assertThisInitialized(_this), 'cancel');
    cov_hm60s0hjm.s[4]++;
    _this.handleOk = _this.handleClick.bind(_assertThisInitialized(_this), 'ok');
    return _this;
  }

  _createClass(Confirm, [{
    key: "handleClick",
    value: function handleClick(type, close) {
      var _this2 = this;

      cov_hm60s0hjm.f[1]++;

      var _ref = (cov_hm60s0hjm.s[5]++, this.props),
          onOk = _ref.onOk,
          onCancel = _ref.onCancel;

      var fn = (cov_hm60s0hjm.s[6]++, type === 'ok' ? (cov_hm60s0hjm.b[0][0]++, onOk) : (cov_hm60s0hjm.b[0][1]++, onCancel));
      var callback;
      cov_hm60s0hjm.s[7]++;

      if (fn) {
        cov_hm60s0hjm.b[1][0]++;
        cov_hm60s0hjm.s[8]++;
        callback = fn();
      } else {
        cov_hm60s0hjm.b[1][1]++;
      }

      cov_hm60s0hjm.s[9]++;

      if ((cov_hm60s0hjm.b[3][0]++, callback) && (cov_hm60s0hjm.b[3][1]++, typeof callback.then === 'function')) {
        cov_hm60s0hjm.b[2][0]++;
        cov_hm60s0hjm.s[10]++;
        this.setState(_defineProperty({}, type, true), function () {
          cov_hm60s0hjm.f[2]++;
          ;
          cov_hm60s0hjm.s[11]++;
          callback.then(function () {
            cov_hm60s0hjm.f[3]++;
            cov_hm60s0hjm.s[12]++;
            close();
            cov_hm60s0hjm.s[13]++;

            _this2.setState(_defineProperty({}, type, false));
          });
        });
      } else {
        cov_hm60s0hjm.b[2][1]++;
        cov_hm60s0hjm.s[14]++;
        close();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      cov_hm60s0hjm.f[4]++;

      var _ref2 = (cov_hm60s0hjm.s[15]++, this.props),
          children = _ref2.children,
          _ref2$type = _ref2.type,
          type = _ref2$type === void 0 ? (cov_hm60s0hjm.b[4][0]++, DefaultProps.type) : _ref2$type,
          text = _ref2.text,
          onOk = _ref2.onOk,
          okType = _ref2.okType,
          onCancel = _ref2.onCancel,
          icon = _ref2.icon,
          other = _objectWithoutProperties(_ref2, ["children", "type", "text", "onOk", "okType", "onCancel", "icon"]);

      var _ref3 = (cov_hm60s0hjm.s[16]++, this.state),
          ok = _ref3.ok,
          cancel = _ref3.cancel;

      cov_hm60s0hjm.s[17]++;
      return (
        /*#__PURE__*/
        React.createElement(Popover, Object.assign({}, other, {
          trigger: "click",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 59,
            columnNumber: 7
          }
        }), function (close) {
          cov_hm60s0hjm.f[5]++;
          cov_hm60s0hjm.s[18]++;
          return (
            /*#__PURE__*/
            React.createElement("div", {
              className: popoverClass('confirm'),
              __self: _this3,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 61,
                columnNumber: 11
              }
            },
            /*#__PURE__*/
            React.createElement("div", {
              className: popoverClass('mention'),
              __self: _this3,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 62,
                columnNumber: 13
              }
            },
            /*#__PURE__*/
            React.createElement(Alert, {
              type: type,
              icon: icon,
              className: popoverClass('alert'),
              __self: _this3,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 63,
                columnNumber: 15
              }
            }, children)),
            /*#__PURE__*/
            React.createElement("div", {
              className: popoverClass('footer'),
              __self: _this3,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 68,
                columnNumber: 13
              }
            },
            /*#__PURE__*/
            React.createElement(Button, {
              loading: cancel,
              size: "small",
              onClick: function onClick() {
                cov_hm60s0hjm.f[6]++;
                cov_hm60s0hjm.s[19]++;
                return _this3.handleCancel(close);
              },
              __self: _this3,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 69,
                columnNumber: 15
              }
            }, getLocale('cancel', text)),
            /*#__PURE__*/
            React.createElement(Button, {
              loading: ok,
              size: "small",
              type: okType,
              onClick: function onClick() {
                cov_hm60s0hjm.f[7]++;
                cov_hm60s0hjm.s[20]++;
                return _this3.handleOk(close);
              },
              __self: _this3,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 72,
                columnNumber: 15
              }
            }, getLocale('ok', text))))
          );
        })
      );
    }
  }]);

  return Confirm;
}(Component);

Confirm.defaultProps = DefaultProps;
export { Confirm as default };